import { FC } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { createComment, getTaskComments } from '../../../api/apis';
import SimpleDialog from '../../Simple/Dialog/SimpleDialog';
import CommentForm from '../../Comments/CommentForm';
import { hour } from '../../../lib/helpers/time.helper';
import { getBaseDomain } from '../../../api/endpointBuilder';

type PostToCommentModalType = {
	codeTaskId: string;
	open: boolean;
	onClose: () => void;
	taskId: number;
};

const PostToCommentModal: FC<PostToCommentModalType> = ({
	codeTaskId,
	open,
	onClose,
	taskId,
}) => {
	const { t } = useTranslation();

	const domain = getBaseDomain();

	const link = `${domain}/code/s/${codeTaskId}`;

	const { refetch } = useQuery<Comment[], Error>(
		[`comments-${taskId}`],
		() => getTaskComments(taskId),
		{
			staleTime: hour,
			onSuccess() {
				onClose();
			},
		},
	);

	const content = (
		<div>
			<CommentForm
				currentTaskId={taskId}
				mutationFn={createComment}
				refetchComments={refetch}
				initialData={{
					comment: 'Here is my solution',
					link,
				}}
			/>
		</div>
	);
	return (
		<SimpleDialog
			title={t('postToComments')}
			content={content}
			open={open}
			onClose={onClose}
		/>
	);
};

export default PostToCommentModal;
